import React, { Fragment } from "react";
import Seo from "../Slot/seo";
import { Box, Flex } from "@chakra-ui/react";
import GameSelector from "../../components/GameComponents/GameSelector/GameSelector";
import GameTypeSelector from "../../components/GameComponents/GameTypeSelector/GameTypeSelector";
import MarqueeList from "../../components/marquee/MarqueeList";
import TopGameBoard from "../../components/GameComponents/TopGameBoard/TopGameBoard";
import useDeviceType from "../../hook/useDeviceType";
import LeaderBoardWrapper from "../../components/GameComponents/LeaderBoard/LeaderBoardWrapper";
import { useSearchParams } from "react-router-dom";
import GameSlideSelector from "../../components/GameComponents/GameSelector/GameSlideSelector";
import JackpotList from "../JackpotList/JackpotList";
import HotTypeMenu from "./components/HotTypeMenu/HotTypeMenu";

const Home = () => {
  const isMobile = useDeviceType() === "Mobile";
  const isTablet = useDeviceType() === "Tablet";
  const isPC = useDeviceType() === "PC";

  const [searchParams] = useSearchParams();

  const searchParamsType = searchParams.get("type") || "Popular";

  return (
    <Fragment>
      <Box minH="calc(100dvh - 110px)" display="flex" flexDirection="column">
        <Box
          // flex="1"
          minH="0" // 這很重要，確保內容不會溢出
          display="flex"
          flexDirection="column"
        >
          <Seo />

          <Flex
            display={{
              base: "none",
              md: "flex",
            }}
            mb="20px"
            mt="15px"
            gap="30px"
          >
            <Box
              flex={1}
              justifyContent="space-between"
              alignItems="center"
              gap="5px"
              mt={{
                md: "0px",
                base: "5px",
              }}
              pt={{
                base: "0px",
                md: "home-space",
              }}
              px={{
                base: "10px",
                md: "0px",
              }}
              ml="auto"
              flexDirection={"column"}
              maxW={{
                md: "calc(100% - 200px)",
                xl: "calc(100% - 300px)",
              }}
              // my="5px"
            >
              <MarqueeList />
              {!isMobile ? (
                <LeaderBoardWrapper>
                  <TopGameBoard />
                </LeaderBoardWrapper>
              ) : null}
              {/* <JackpotList /> */}
            </Box>
          </Flex>
          {isMobile ? (
            <Box mt="10px">
              <MarqueeList />

              <LeaderBoardWrapper>
                <TopGameBoard />
              </LeaderBoardWrapper>
            </Box>
          ) : null}
        </Box>
        <Flex flex={{ base: 1, md: "none" }}>
          <Box
            py={{
              // md: "home-space",
              base: "0",
            }}
            display={{
              base: "block",
              sm: "none",
            }}
            // pl="common-y"
            pr="5px"
          >
            <GameTypeSelector gameMainTypeFromProps={"SLOT"} />
          </Box>
          <Flex
            overflowX={{
              base: "scroll",
              lg: "hidden",
            }}
            flex={1}
            justifyContent="space-between"
            gap="10px"
          >
            <Box
              flex="none" // 確保這部分不會被拉伸
              w={{
                base: "100%",
                // xl: "calc(100% - 150px)",
              }}
              py={{
                base: 0,
                md: "home-space",
              }}
              mb={{
                base: "60px",
                sm: "0px",
              }}
            >
              {/* 手機板TOP GAME */}
              {isPC || isTablet ? (
                <>
                  <Box
                    // px={{
                    //   base: "common-y",
                    //   md: "10px",
                    // }}
                    maxW={{
                      md: "calc(100% - 200px)",
                      xl: "calc(100% - 150px)",
                    }}
                    ml="auto"
                    display={{ base: "none", md: "block" }}
                  >
                    <GameSlideSelector />
                  </Box>
                </>
              ) : (
                <>
                  <Box display={{ base: "block", xl: "block" }}>
                    <Box
                      display={{
                        base: "block",
                        md: "none",
                      }}
                    >
                      <HotTypeMenu />
                    </Box>
                    <Box id="HOT">
                      <GameSelector
                        // gameMainTypeFromProps={"HOT"}
                        hiddenTitle
                        customSubType={searchParamsType}
                        isHighlight
                        sliceCount={10}
                        isHot
                        topLayout={!isMobile && !isTablet}
                        // isGridXLayout
                      />
                    </Box>
                  </Box>
                </>
              )}
            </Box>
          </Flex>
        </Flex>
      </Box>
    </Fragment>
  );
};

export default Home;
